const createFishShape3 = shape => {
  shape.moveTo(40.2003, 25.8358);
  shape.bezierCurveTo(55.1498, 24.8557, 58.1642, 20.5571, 60.8008, 11.561);
  shape.bezierCurveTo(60.9212, 11.15, 60.7625, 10.7049, 60.4062, 10.4671);
  shape.bezierCurveTo(55.7503, 7.36066, 52.2096, 6.32855, 45.7052, 5.29844);
  shape.bezierCurveTo(45.4176, 5.25289, 45.162, 5.08336, 45.0037, 4.8389);
  shape.bezierCurveTo(43.6688, 2.77715, 42.4183, 1.5449, 40.4407, 0.263962);
  shape.bezierCurveTo(39.6856, -0.225149, 38.7741, 0.516912, 38.8461, 1.41372);
  shape.bezierCurveTo(38.909, 2.19842, 38.8228, 2.98568, 38.5283, 3.97587);
  shape.bezierCurveTo(38.4082, 4.37967, 38.0274, 4.6442, 37.6061, 4.64842);
  shape.bezierCurveTo(33.7413, 4.68713, 31.3213, 4.90022, 27.6287, 5.6457);
  shape.bezierCurveTo(27.1636, 5.73961, 26.632, 5.52702, 26.2288, 5.27667);
  shape.bezierCurveTo(25.1426, 4.60216, 22.9846, 3.82153, 22.6141, 3.68967);
  shape.bezierCurveTo(22.5765, 3.67629, 22.5456, 3.6626, 22.5085, 3.64799);
  shape.bezierCurveTo(21.1049, 3.09612, 13.1521, 4.61429, 12.4224, 8.85195);
  shape.bezierCurveTo(12.314, 9.48141, 11.8119, 10.052, 11.1745, 10.0098);
  shape.lineTo(9.71322, 9.91292);
  shape.bezierCurveTo(9.55905, 9.9027, 9.40789, 9.85585, 9.27403, 9.77869);
  shape.bezierCurveTo(6.28557, 8.0561, 4.23204, 7.29877, 1.69844, 6.9009);
  shape.bezierCurveTo(0.757786, 6.75319, 0.2215, 7.94881, 0.751823, 8.73965);
  shape.bezierCurveTo(1.07373, 9.21969, 1.43791, 9.82932, 1.88388, 10.648);
  shape.bezierCurveTo(1.96299, 10.7933, 2.00424, 10.9569, 2.00424, 11.1223);
  shape.lineTo(2.00424, 13.1972);
  shape.bezierCurveTo(2.00424, 13.3311, 1.97711, 13.4645, 1.92451, 13.5877);
  shape.bezierCurveTo(1.35218, 14.9278, 0.862495, 15.9364, 0.277645, 16.8059);
  shape.bezierCurveTo(-0.276611, 17.6298, 0.335983, 18.9542, 1.30786, 18.7503);
  shape.bezierCurveTo(3.85051, 18.2167, 6.03226, 17.2811, 9.23373, 15.3036);
  shape.bezierCurveTo(9.39298, 15.2053, 9.57805, 15.1515, 9.76523, 15.1515);
  shape.lineTo(10.8489, 15.1515);
  shape.bezierCurveTo(11.4137, 15.1515, 11.8611, 15.6207, 11.9058, 16.1837);
  shape.bezierCurveTo(12.6856, 26.0025, 28.8998, 33.3674, 39.676, 26.0175);
  shape.bezierCurveTo(39.8294, 25.9129, 40.015, 25.848, 40.2003, 25.8358);

  return shape;
};

export default createFishShape3;
